<div class="timeline-holder right">
    <div class="content">
      <h2>September - 2020</h2>
      <p>Badges and Awards introduced</p>
    </div>
  </div>
